import { createReducer } from '@reduxjs/toolkit';
import {
    SET_IF_HAS_ACTIVE_HUNT,
    SET_USER_WON_PREMIO,
    SET_CHECKED_RESERVED_PRIZE,
    SET_SHOW_MODAL,
    SET_SHOW_SIGN,
} from '../actions/CacaAoTesouroGlobalCheckAction';

const initialState = {
    checkedReservedPrize: false,
    hasActiveHunt: null,
    userWonPremio: null,
    showModal: false,
    showSign: true,
};

const cacaAoTesouroGlobalCheck = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_IF_HAS_ACTIVE_HUNT, (state, action) => {
            state.hasActiveHunt = action.hasActiveHunt;
        })
        .addCase(SET_USER_WON_PREMIO, (state, action) => {
            state.userWonPremio = action.prizeWon;
        })
        .addCase(SET_CHECKED_RESERVED_PRIZE, (state, action) => {
            state.checkedReservedPrize = action.checkedReservedPrize;
        })
        .addCase(SET_SHOW_MODAL, (state, action) => {
            state.showModal = action.showModal;
        })
        .addCase(SET_SHOW_SIGN, (state, action) => {
            state.showSign = action.showSign;
        });
});

export default cacaAoTesouroGlobalCheck;
